import { Navbar } from "./components/navbar/index";
//import Sermones from "./components/ultimosSermones";

function App() {
  return <Navbar />;
}

export default App;
